import { __makeTemplateObject } from "tslib";
import React, { useCallback, useMemo } from 'react';
import { format, getYear } from 'date-fns';
import styled from 'styled-components';
import { SCalendarLeftButtonIcon, SCalendarRightButtonIcon, } from './DatePicker.styled';
import { UnstyledSelect } from '../UnstyledSelect/UnstyledSelect';
export var DatePickerHeader = function (_a) {
    var date = _a.date, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, changeYear = _a.changeYear, prevMonthButtonDisabled = _a.prevMonthButtonDisabled, nextMonthButtonDisabled = _a.nextMonthButtonDisabled, locale = _a.locale, minDate = _a.minDate, maxDate = _a.maxDate;
    var yearSelectHandler = useCallback(function (e) {
        changeYear(Number(e.target.value));
    }, [changeYear]);
    var yearOptions = useMemo(function () {
        var startYear = getYear(minDate);
        var endYear = getYear(maxDate);
        var years = [];
        for (var year = endYear; year >= startYear; year--) {
            years.push(year);
        }
        return years;
    }, [minDate, maxDate]);
    return (React.createElement("div", { className: "react-datepicker__navigation" },
        React.createElement("button", { type: "button", disabled: prevMonthButtonDisabled, onClick: decreaseMonth, className: "react-datepicker__navigation--previous", "aria-label": "Previous Month" },
            React.createElement(SCalendarLeftButtonIcon, null)),
        React.createElement("p", { className: "react-datepicker__navigation--current-month" },
            format(date, 'MMMM', { locale: locale }),
            "\u00A0",
            React.createElement(SYearSelection, null,
                format(date, 'y', { locale: locale }),
                React.createElement(UnstyledSelect, { onChange: yearSelectHandler, value: getYear(date) }, yearOptions.map(function (year) { return (React.createElement("option", { key: year, value: year }, year)); })))),
        React.createElement("button", { type: "button", disabled: nextMonthButtonDisabled, onClick: increaseMonth, className: "react-datepicker__navigation--next", "aria-label": "Next Month" },
            React.createElement(SCalendarRightButtonIcon, null))));
};
var SYearSelection = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var templateObject_1;
//# sourceMappingURL=DatePickerHeader.js.map